/**
 * defa.models.RecipientGroup
 * The DEFA RecipientGroup model.
 * @version 1.0.0
 */

import Model      from '../../poppet/model';
import { defa }   from '../../../defa-object';
import Recipients from './collection-recipients';

const channel = Bb.Radio.channel( 'objects' );

const apiHost = defa.vars.apiHost;
const api     = {
	unitUrl        : apiHost,
	recipientGroups: '/notificationgroups',
};

export const RecipientGroup = Model.extend( {
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: {
		name                  : '',
		notificationRecipients: [],
	},
	
	url: function () {
		return this.get( 'id' )
			   ? apiHost + api.recipientGroups + '/' + this.get( 'id' )
			   : apiHost + api.recipientGroups;
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	/**
	 * Parses incoming data before creating/updating the model.
	 * @param  {object} response  The response from the server.
	 * @overwrite
	 */
	parse: function ( response ) {
		if ( response ) {
			this.set({id : response.id});
			this.set({notificationRecipients: new Recipients(response.notificationRecipients)})
			let recipientGroupHolder = channel.request( 'recipientGroupHolders' ).get( this.get( 'unit' ) );
			recipientGroupHolder.get( 'recipientGroups' ).add( this, { merge: true } );
		}
	},
	
	
	/**
	 * Filters the recipients.
	 * @return {Array[]} A list containing only the email recipients .
	 */
	getEmailRecipients: function () {
		return this.get( 'notificationRecipients' ).filter( function ( recipient ) {
			return recipient.get( 'type' ) === 'EMAIL';
		} );
	},
	
	/**
	 * Filters the recipients.
	 * @return {Array[]} A list containing only the sms recipients .
	 */
	getSmsRecipients: function () {
		return this.get( 'notificationRecipients' ).filter( function ( recipient ) {
			return recipient.get( 'type' ) === 'SMS';
		} );
	},
} );
export default RecipientGroup;